export enum BuyProductStatus {
  INIT = 'Init',
  SENDING = 'Sending',
  SENT = 'Sent',
  ERROR = 'Error',
}
